module.exports = __webpack_public_path__ + "media/images/bath_icon@3x-5e2dc8ce.png";